import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static classes = ['expanded']

  connect () {
    this.synchronizeControlledTarget()
  }

  toggle () {
    this.expanded = !this.expanded
  }

  // Private

  synchronizeControlledTarget () {
    if (this.hasExpandedClass) {
      this.controlledTarget.classList.toggle(this.expandedClass, this.expanded)
    } else {
      this.controlledTarget.hidden = !this.expanded
    }
  }

  get controlledTarget () {
    return document.getElementById(this.element.getAttribute('aria-controls'))
  }

  set expanded (expanded) {
    this.element.setAttribute('aria-expanded', expanded)

    this.synchronizeControlledTarget()
  }

  get expanded () {
    return this.element.getAttribute('aria-expanded') === 'true'
  }
}
